import NotificationList from "@/features/notifications/ui/notification-list";

export default function Notifications() {
  return <NotificationList />;
}
